/**
 * Custom hook for managing date range selection
 */
import { useEffect, useRef, useState } from "react";

interface UseDateRangeOptions {
  initialStartDate?: string | null;
  initialEndDate?: string | null;
}

export function useDateRange(options: UseDateRangeOptions = {}) {
  const hasInitialRange = Boolean(
    options.initialStartDate && options.initialEndDate,
  );
  const [dateRange, setDateRange] = useState(
    hasInitialRange ? "custom" : "last7days",
  );
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [customStartDate, setCustomStartDate] = useState(
    options.initialStartDate ?? "",
  );
  const [customEndDate, setCustomEndDate] = useState(
    options.initialEndDate ?? "",
  );
  const [compareToPrevious, setCompareToPrevious] = useState(true);
  const datePickerRef = useRef<HTMLDivElement | null>(null);

  // Close date picker when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        datePickerRef.current &&
        !datePickerRef.current.contains(event.target as Node)
      ) {
        setShowDatePicker(false);
      }
    };

    if (showDatePicker) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showDatePicker]);

  return {
    dateRange,
    setDateRange,
    showDatePicker,
    setShowDatePicker,
    customStartDate,
    setCustomStartDate,
    customEndDate,
    setCustomEndDate,
    compareToPrevious,
    setCompareToPrevious,
    datePickerRef,
  };
}
